<script lang="ts">
	import { onMount } from 'svelte';
	if (import.meta.env.VITE_DATADOG_APPLICATION_ID) {
		onMount(async () => {
			// Load DatadogRum Browser Agent inside onMount to avoid SSR issues
			const { datadogRum } = await import('@datadog/browser-rum');
			datadogRum.init({
				applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
				clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
				// `site` refers to the Datadog site parameter of your organization
				// see https://docs.datadoghq.com/getting_started/site/
				site: import.meta.env.VITE_DATADOG_SITE,
				service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
				env: import.meta.env.VITE_DATADOG_ENV,
				// Specify a version number to identify the deployed version of your application in Datadog
				version: import.meta.env.VITE_DATADOG_VERSION,
				sessionSampleRate: 100,
				sessionReplaySampleRate: 20,
				trackBfcacheViews: true,
				defaultPrivacyLevel: 'mask-user-input',
				trackResources: true,
				allowedTracingUrls: [/\/api\/content\//, /\/api\/search\//, /\/api\/transactional\//],
				trackLongTasks: true,
				trackUserInteractions: true,
			});
		});
	}
</script>
